import { useCallback } from 'react';

import { IntlShape, useIntl } from 'react-intl';

import { IConfigOffer, ILimit } from 'generated/sanity-graphql';
import { IncentiveEvaluationErrorCodes } from 'state/loyalty/hooks/types';
import { LoyaltyOffer } from 'state/loyalty/types';

import { incentiveHasEvaluationError } from './utils';

type TConfigList = ReadonlyArray<Pick<IConfigOffer, '_id' | 'rules'> | null>;

const getExceedsMaxRedemptionErrorMessage = (
  incentive: LoyaltyOffer,
  { formatMessage }: IntlShape,
  configOffers?: TConfigList
) => {
  if (configOffers) {
    const configOffer = configOffers?.find(configOffer => configOffer?._id === incentive._id);

    if (configOffer) {
      const limitRule = configOffer.rules?.find(
        (rule): rule is ILimit => rule?.__typename === 'Limit'
      );

      switch (limitRule?.interval) {
        case 'day':
          return formatMessage({
            id: 'availableAgainTomorrow',
            defaultMessage: 'Available Again Tomorrow',
          });
        default:
          return formatMessage({ id: 'offerNotAvailable' });
      }
    }

    return formatMessage({ id: 'offerNotAvailable' });
  }
  return formatMessage({ id: 'offerNotAvailable' });
};

export const useWalmartSeasonalPromoAvailabilityUtils = (configOffers?: TConfigList) => {
  const intl = useIntl();

  const getIncentiveUnavailableMessage = useCallback(
    (incentive: LoyaltyOffer) => {
      // if (true) {
      if (
        incentiveHasEvaluationError(incentive, IncentiveEvaluationErrorCodes.EXCEEDS_MAX_REDEMPTION)
      ) {
        return getExceedsMaxRedemptionErrorMessage(incentive, intl, configOffers);
      }

      // Empty string if no issues found
      return '';
    },
    [intl, configOffers]
  );

  return { getIncentiveUnavailableMessage };
};
